import React, { useEffect } from "react";
import { useParams } from "react-router";
import api from "../../common/lib/api";
import BillingPeriod from "./BillingPeriod";
import CommandsStage from "./CommandsStage";
import CompanyLinksReviewStage from "./CompanyLinksReviewStage";
import InvoiceExportStage from "./InvoiceExportStage";
import InvoiceEmailStage from "./InvoiceEmailStage";
import Managed, { useManaged } from "../../common/components/Managed";
import StageHeader from "./StageHeader";

const INTIAL_STATE = {
  stages: [],
};

export default function BillPage() {
  const { system, period } = useParams();
  const [state, setData, setError] = useManaged(INTIAL_STATE);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/bill/${system}/${period}`);
        setData({ ...data });
      } catch (e) {
        setError(e);
      }
    })();
  }, [period, system, setData, setError]);

  return (
    <Managed state={state}>
      <h1>Billing {state.data.period}</h1>
      <BillingPeriod system={system} state={state.data} />

      {state.data.stages.map((stage, stageIndex) => {
        let Renderer = StageHeader;
        switch (stage.type) {
          case "commands":
            Renderer = CommandsStage;
            break;
          case "companyLinks":
            Renderer = CompanyLinksReviewStage;
            break;
          case "invoiceExport":
            Renderer = InvoiceExportStage;
            break;
          case "invoiceEmailExported":
            Renderer = InvoiceEmailStage;
            break;
          default:
            console.error(`No renderer found for ${stage.type}`);
        }
        return (
          <Renderer
            key={`stage-${stageIndex}-${stage.stage}`}
            stageIndex={stageIndex}
            period={state.data.period}
            stage={stage}
            system={system}
          />
        );
      })}
    </Managed>
  );
}
